import React, { useEffect, useContext, useState } from "react";
import "../../sass/blocks/_contest-question.scss";
import ContestQuestion from "./ContestQuestion";
import { StepContext } from "../../context/StepContext";
import { QuestionsContext } from "../../context/QuestionsContext";
import ApiService from "../../services/api.service";
import ContestQuestionUserAnswers from "./ContestQuestionUserAnswers";

/** Context */
import { UserContext } from "../../context/UserContext";

const ContestQuestions = (props) => {
    const { pageID } = props;

    const [questionIndex, setQuestionIndex] = useState(0);
    const { step, setStep } = useContext(StepContext);
    const { questions, setQuestions } = useContext(QuestionsContext);

    const userData = useContext(UserContext);

    const nextQuestionHandler = () => {
        if (questionIndex < Object.values(questions).length - 1) {
            setQuestionIndex(questionIndex + 1);
        } else {
            setStep(step + 1);
        }
    };

    const prevQuestionHandler = () => {
        if (questionIndex > 0) {
            setQuestionIndex(questionIndex - 1);
        } else {
            setStep(step - 1);
        }
    };

    useEffect(() => {
        ApiService.getQuestions(pageID).then((response) => {
            setQuestions(response);
        });

        ApiService.startQuestionaire({
            user_id: userData.user,
            page_id: pageID,
        });
    }, []);

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: "smooth" });
    }, [questionIndex, step]);

    return (
        <>
            <div className="contest">
                <div className="contest-question">
                    {Object.keys(questions).map((key) => {
                        return (
                            <div
                                className={`contest-question__element ${
                                    key == questionIndex
                                        ? "contest-question__element--active"
                                        : ""
                                }`}
                                key={key}
                            >
                                {!questions[key].only_users_answers ? (
                                    <ContestQuestion
                                        background={props.background}
                                        color={props.color}
                                        questionsLength={questions.length}
                                        question={questions[key]}
                                        index={key}
                                        usersAnswearsOnly={
                                            questions[key].only_users_answers
                                        }
                                        usersAnswersOnlyImg={
                                            questions[key]
                                                .users_answers_only_img
                                        }
                                        prevQuestionHandler={
                                            prevQuestionHandler
                                        }
                                        nextQuestionHandler={
                                            nextQuestionHandler
                                        }
                                    />
                                ) : (
                                    <ContestQuestionUserAnswers
                                        background={props.background}
                                        color={props.color}
                                        questionsLength={questions.length}
                                        question={questions[key]}
                                        index={key}
                                        prevQuestionHandler={
                                            prevQuestionHandler
                                        }
                                        nextQuestionHandler={
                                            nextQuestionHandler
                                        }
                                    />
                                )}
                            </div>
                        );
                    })}
                </div>
            </div>
        </>
    );
};

export default ContestQuestions;
